import { TaskCreationSourceKind } from "./IGraphTaskCreationResource";
/**
 * Checks if the given resource is a GraphTeamsPublicationInfoResource
 * @param resource The resource to check
 * @returns True if the resource is a GraphTeamsPublicationInfoResource
 */ export function isGraphTeamsPublicationInfoResource(resource) {
    return resource.creationSourceKind === TaskCreationSourceKind.Publication;
}
